<button class="pos-relative w-12 flex flex-justify-between flex-middle"
        [class.disabled]="status.busy">
    <div class="inline-block">
        @if (welcomeOffer) {
        {{'Welcome offer' | translate}}
        } @else {
        {{'Store Credit' | translate}}
        }
        <action class="inline-block m-l-1"
                [status]="status"
                (click)="toggle()">
            <span class="cursor-pointer underline">{{'Remove' | translate}}</span>
        </action>
    </div>
    <price class="price"
           [value]="used * -1" />
    @if (status.busy) {
    <span class="pos-absolute top-0 right-8 bottom-0 flex flex-middle flex-justify-center pe-none">
        <i class="icon-loading"
           aria-hidden="true"></i>
    </span>
    }
</button>
